export default {
  sm: `
  DATA CENTER GAK keeps the spirit of
  Janggyeonggak alive that has been
  protecting Tripitaka Koreana for over
  500 years. We at NAVER named our
  DATA CENTER GAK bearing the tremendous
  responsibility and mission to pass the
  humanity's valuable knowledge onto future
  generations.
  `,
  md: `
  DATA CENTER GAK keeps the spirit of
  Janggyeonggak alive that has been
  protecting Tripitaka Koreana for over
  500 years. We at NAVER named our data
  center GAK bearing the tremendous
  responsibility and mission to pass the
  humanity's valuable knowledge onto future
  generations.
  `,
  lg: `
  DATA CENTER GAK keeps the spirit of
  Janggyeonggak alive that has been protecting
  Tripitaka Koreana for over 500 years. We at NAVER
  named our DATA CENTER GAK bearing the
  tremendous responsibility and mission to pass the
  humanity's valuable knowledge onto future
  generations.
  `,
  xxl: `
  DATA CENTER GAK keeps the spirit of Janggyeonggak alive
  that has been protecting Tripitaka Koreana for over 500 years.
  We at NAVER named our DATA CENTER GAK bearing the tremendous
  responsibility and mission to pass the humanity's valuable
  knowledge onto future generations.
  `,
};
